// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WRm9AvCgUveRON5TrcML {
  background-color: var(--dry-progress-bg);
  border-radius: var(--dry-border-radius);
  overflow: hidden;
}
.WRm9AvCgUveRON5TrcML > div {
  background-color: var(--dry-progress-color);
  border-radius: var(--dry-border-radius);
  height: 0.4em;
  transform-origin: 0 0;
  transition: all 0.8s;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `WRm9AvCgUveRON5TrcML`
};
export default ___CSS_LOADER_EXPORT___;
